/**
 * DataList + DataRow: lista vertical de pares label/value (card "Mis
 * datos" del Dashboard del vecino).
 *
 * Sprint 11 v2 S11-V2-06. Replica `.cb-data-list` del handoff
 * (`docs/COMPONENTES.md § Data list`).
 */
import type { ReactNode } from 'react';

interface DataListProps {
  children: ReactNode;
}

interface DataRowProps {
  label: ReactNode;
  value: ReactNode;
}

export function DataList({ children }: DataListProps) {
  return <div className="flex flex-col gap-2 text-base">{children}</div>;
}

export function DataRow({ label, value }: DataRowProps) {
  return (
    <div className="flex justify-between">
      <span className="text-text-secondary">{label}</span>
      <span className="text-text-primary">{value}</span>
    </div>
  );
}
